import apiPostRequest from './base/api-post-request'

const userAuthenticate = (email, tenant) => apiPostRequest('/auth')({
  email,
  tenant,
  domain: document.location.hostname
})

export default userAuthenticate